<template>
  <div class="basic-block block-lead-subsc" :style="styles">
    <img v-if="targetInfo.leadSubsc.deco" :src="targetInfo.leadSubsc.deco" class="block-lead-subsc__deco" alt="">
    <div class="content-wrap">
      <div class="block-lead-subsc__inner">
        <h3 class="block-lead-subsc__title">月528円で全部見られる！</h3>
        <p class="block-lead-subsc__lead">1ヶ月定額528円（税込み）で<br>さまざまな占い師の占いが見られます。<br>毎日更新されるので、<br>どんなお悩みにも<br>ぴったりなものが見つかるはず。<br>あなたの日常に寄り添う占いを<br>ずっと楽しむなら占いTV。</p>
        <lp-base-button label="もっと占ってみる" design="fill" :color-scheme="colorScheme" class="block-lead-subsc__btn" @clicked="clicked" />
      </div>
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockLeadSubsc',
  components: {
    LpBaseButton,
  },
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    subscUrl: String,
  },
  computed: {
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked() {
      location.href = this.subscUrl
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
.block-lead-subsc {
  padding: 48px 0 40px;
  background: #fff;
  &__deco {
    position: absolute;
    top: -45px;
    left: 0;
    width: 17.6%;
    max-width: 80px;
    z-index: 101;
  }
  &__inner {
    padding: 0 20px;
  }
  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 21px;
    text-align: center;
    color: $l_col_second;
    margin: 0 0 28px;
  }
  &__lead {
    font-weight: bold;
    font-size: 16px;
    line-height: 34px;
    text-align: center;
    letter-spacing: 1px;
    color: $l_col_keycolor;
    margin: 0 0 24px;
  }
  &__btn {
    max-width: 270px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/blocks/BlockLeadSubsc.vue